<div class="container">
    <div class="left">
        <div class="content-chart" #contentChart>
            <div id="chart"></div>
            <div *ngFor="let title of dimensionTitles" class="chart-dimension-title" [ngStyle]="title.style">
                {{ title.name }}
            </div>
        </div>
    </div>
    <div class="right">
        <h1 class="titulo-tabla">Gráfico comparativo</h1>
        <div class="tabla-container">
            <table class="tabla-comparativa">
                <thead>
                    <tr>
                        <th>Dimensión</th>
                        <th>Subdimensión</th>
                        <th>Hoy</th>
                        <th>7 Años</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let dimension of test.dimensions; let dimIndex = index">
                        <ng-container *ngFor="let question of dimension.questions; let qIndex = index">
                            <tr>
                                <!-- Dimensión (solo en la primera fila de cada grupo) -->
                                <td *ngIf="qIndex === 0" [attr.rowspan]="dimension.questions.length" class="dimension-column" [ngStyle]="getDimensionStyles(dimension.name)">
                                    <div class="dimension-text">{{ dimension.name }}</div>
                                </td>
                                
                                <!-- Subdimensión -->
                                <td class="question-name">
                                    <span class="code-label">{{ getCodeLabel(dimIndex, qIndex) }}</span> - {{ question.name }}
                                </td>
                                
                                <!-- Valores -->
                                <td class="question-value hoy-value">{{ question.answer.valueNow }}</td>
                                <td class="question-value future-value">{{ question.answer.valueFuture }}</td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div class="buttons-container">
            <button class="btn-volver" (click)="return()">Volver</button>
            <button class="btn-agendar" [routerLink]="['/dashboard/mentors']" >Agendar con tu mentor</button>
            <button class="btn-descargar" (click)="downloadPdf()">Descargar Informe en PDF</button>
        </div>
    </div>
</div>